import React from "react";
import { Tabs } from "antd";
import { withTranslation } from 'react-i18next';
import LeadFormTaskSidebar from './LeadFormTaskSIdebar';
import LeadFormEventSidebar from './LeadFormEventSidebar';
import LeadFormContactSidebar from './LeadFormContactSidebar';
import CommentView from "../Comments/CommentView";
import LeadFormServiceRequestSidebar from "./LeadFormServiceRequestSidebar";
import { orderBy } from 'lodash';


const { TabPane } = Tabs;

class LeadFormSidebar extends React.Component {
  state = ({

  });


  render() {
    const { t, lead } = this.props;
    const [p] = [this.props]
    return (
      <div>
        <Tabs defaultActiveKey="tasks">
          <TabPane tab={t('leads.lead_form_sidebar.tasks', "Tasks")} key="tasks">
            <LeadFormTaskSidebar
              tasks={p.lead.tasks}
              lead={p.lead}
              task_status={p.task_status}
              task_priority={p.task_priority}
              leads={p.leads}
              tags={p.tags}
              contacts={p.contacts}
              users={p.users}
              fetch={p.fetchSingle}
              handleState={p.handleState}
              loading={p.loading}
            />
          </TabPane>
          <TabPane tab={t('leads.lead_form_sidebar.comments', "Comments")} key="comments">
            <CommentView data={lead} comment_on='lead' comments={orderBy(lead.comments, 'commented_on', 'desc')} fetch={this.props.fetchSingle} />
          </TabPane>
          <TabPane tab={t('leads.lead_form_sidebar.contacts', "Contacts")} key="contacts">
            <LeadFormContactSidebar
              contacts={this.props.lead.contacts} lead={this.props.lead}
              fetch={this.props.fetchSingle} handleState={this.props.handleState} loading={this.props.loading}
            />
          </TabPane>
          <TabPane tab={t('leads.lead_form_sidebar.events', "Events")} key="events">
            <LeadFormEventSidebar
              events={this.props.lead.events} lead={this.props.lead} event_status={this.props.event_status} event_type={this.props.event_type}
              leads={this.props.leads} tags={this.props.tags} contacts={this.props.contacts} users={this.props.users}
              fetch={this.props.fetchSingle} handleState={this.props.handleState} loading={this.props.loading}
            />
          </TabPane>


          {/* <TabPane tab="Attachments" key="attachments">
                        Content of Tab Pane 5
                    </TabPane> */}
          <TabPane tab={t('leads.lead_form_sidebar.service_requests', "Service Requests")} key="service_requests">
            <LeadFormServiceRequestSidebar data={this.props.lead.service_request} />
          </TabPane>
        </Tabs>
      </div>
    );
  }
};

export default withTranslation()(LeadFormSidebar);


// WEBPACK FOOTER //
// ./src/containers/Leads/LeadFormSidebar.js